import { Settings } from './settings/settings';
/*
all objectstores need to be registerd in indexed-dbservice (public static readonly objectStores) and also in constructor from abstract-object-store
 */

export interface ObjectStore<T> {
  objectStoreName: string;
  keyPath: keyof T;
}

export const settingsObjectStore: ObjectStore<Settings> = {
  objectStoreName: 'settings',
  keyPath: 'key',
};
